import imgLogoAttivo from 'assets/img/datasources/light/logo-attivo.png';
import imgLogoOkta from 'assets/img/datasources/light/logo-okta.png';
import imgLogoSentinelOne from 'assets/img/datasources/light/logo-sentinelone.png';
import imgLogoVectra from 'assets/img/datasources/light/logo-vectra.png';

import imgLogoDarkAttivo from 'assets/img/datasources/dark/logo-attivo.png';
import imgLogoDarkOkta from 'assets/img/datasources/dark/logo-okta.png';
import imgLogoDarkSentinelOne from 'assets/img/datasources/dark/logo-sentinelone.png';
import imgLogoDarkVectra from 'assets/img/datasources/dark/logo-vectra.png';

import { DATASOURCE } from 'schemas';
import { ThemeInfo } from 'styles/stylesProvider/themes';

const dataSourceLogosLight: { [key in DATASOURCE]?: string } = {
  [DATASOURCE.ATTIVO]: imgLogoAttivo,
  [DATASOURCE.OKTA]: imgLogoOkta,
  [DATASOURCE.SENTINEL_ONE]: imgLogoSentinelOne,
  [DATASOURCE.VECTRA]: imgLogoVectra,
};

const dataSourceLogosDark: { [key in DATASOURCE]?: string } = {
  [DATASOURCE.ATTIVO]: imgLogoDarkAttivo,
  [DATASOURCE.OKTA]: imgLogoDarkOkta,
  [DATASOURCE.SENTINEL_ONE]: imgLogoDarkSentinelOne,
  [DATASOURCE.VECTRA]: imgLogoDarkVectra,
};

export const getDataSourceLogo = (dataSource?: string | DATASOURCE, theme?: ThemeInfo) => {
  const dataSourceLogos = theme?.isDark ? dataSourceLogosDark : dataSourceLogosLight;

  return dataSource && dataSourceLogos[dataSource.toUpperCase() as DATASOURCE];
};
